import { authStore } from '../../global-store/subjects/auth';
import { removeAllListeners, unHideElement } from '../../utils/dom-utils';
import { getLoginUrl } from '../../utils/build-urls';
import { initDatalayerElement } from '../tracking/datalayer';

export const init = ($paywall) => {
  const $sectionDividerWithCta = $paywall.querySelector('.c-section-divider--with-cta');
  authStore.subscribe(({ isLoginLoading, isUserLogged }) => {
    if (!isLoginLoading && !isUserLogged) {
      // Update cta url (abbonati)
      const $ctaSubscribe = $paywall.querySelector('.c-info-box--bottom.c-info-box--with-price .c-cta');
      const ctaSubscribeForwardUrl = $ctaSubscribe.getAttribute('href');
      const ctaSubscribeLoginUrl = getLoginUrl(ctaSubscribeForwardUrl);
      $ctaSubscribe.setAttribute('href', ctaSubscribeLoginUrl);
      const ctaSubscribeIntcmp = $ctaSubscribe.getAttribute('data-intcmp');
      $ctaSubscribe.removeAttribute('data-intcmp');
      $ctaSubscribe.setAttribute('data-intcmp-qp', ctaSubscribeIntcmp);
      const $clonedCtaSubscribe = removeAllListeners($ctaSubscribe);
      initDatalayerElement($clonedCtaSubscribe.parentElement);

      // Update cta url (accedi)
      const $ctaLogin = $paywall.querySelector('.c-paywall__footer .c-cta');
      const ctaLoginForwardUrl = window.location.href;
      const ctaLoginUrl = getLoginUrl(ctaLoginForwardUrl);
      $ctaLogin.setAttribute('href', ctaLoginUrl);
      unHideElement($sectionDividerWithCta);
    }
  });
};
